export const readableGender = {
  MALE: 'labels.gender.male',
  FEMALE: 'labels.gender.female',
  DIVERS: 'labels.gender.diverse'
}
